export default function setProvinceAction(province) {
    return {
        type: 'SET_PROVINCE',
        payload: province
    }
}